import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPypiComponent } from './simple-icons-pypi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPypiComponent ],
    exports:      [ SimpleIconsPypiComponent ],
    bootstrap:    []
})
export class SimpleIconsPypiModule {}
